import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "spacing"];
import "core-js/modules/es.array.map.js";
import React from 'react';
import styled from 'styled-components';
var ListElement = styled.ul.withConfig({
  displayName: "BulletList__ListElement",
  componentId: "sc-1ihjuaw-0"
})(["list-style:disc;"]);
var ListItem = styled.li.withConfig({
  displayName: "BulletList__ListItem",
  componentId: "sc-1ihjuaw-1"
})(["margin-left:", ";padding-bottom:", ";&:last-child{padding-bottom:0;}"], function (p) {
  return p.theme.globals.spacing.m;
}, function (p) {
  return p.theme.globals.spacing[p.spacing];
});
var BulletList = function BulletList(_ref) {
  var children = _ref.children,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 'xxs' : _ref$spacing,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ListElement, otherProps, React.Children.map(children, function (child, i) {
    if (child) {
      return /*#__PURE__*/React.createElement(ListItem, {
        key: i,
        spacing: spacing
      }, child);
    }
  }));
};
export default BulletList;